import { putApi } from 'api/fetchApi'
import { definitions, paths } from 'api/generated/photorating'

type Method = paths['/ratings/featured_photos/photos/{photoId}/archived']

type Body = Method['put']['parameters']['path']
type Result = Method['put']['responses']['200']['schema']

export const fetchArchivedFeaturedPhotoApi = async (
  inActiveFeaturePhotosList: definitions['FeaturedPhoto'][]
) => {
  const promises = inActiveFeaturePhotosList.map((photoObject) => {
    const photoId = photoObject.photoId
    return putApi<Result, Body>(
      `/ratings/featured_photos/photos/${photoId}/archived` as keyof paths,
      {
        photoId,
      }
    )
  })

  const result = await Promise.all(promises)

  return Math.max(...result.map((item) => item.result!.ratio))
}
